export default __webpack_public_path__ + "static/media/bg_gradi_right02.6f829513.png";